
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.1 14.092l-2.496-2.496a.502.502 0 00-.345-.15.466.466 0 00-.363.15.49.49 0 00-.16.354c0 .13.054.247.16.354l2.638 2.638c.162.162.35.242.566.242.215 0 .404-.08.566-.242l5.476-5.476a.504.504 0 00.15-.345.467.467 0 00-.15-.363.49.49 0 00-.354-.16.491.491 0 00-.354.16L11.1 14.092zM6.116 20c-.46 0-.845-.154-1.153-.462a1.565 1.565 0 01-.463-1.154V5.616c0-.46.154-.845.463-1.153A1.565 1.565 0 016.115 4h12.77c.46 0 .844.154 1.152.463.309.308.463.692.463 1.152v12.77c0 .46-.154.844-.462 1.152a1.565 1.565 0 01-1.154.463H6.116zm0-1h12.768a.588.588 0 00.424-.192.588.588 0 00.192-.424V5.616a.588.588 0 00-.192-.424.588.588 0 00-.424-.192H6.116a.588.588 0 00-.424.192.588.588 0 00-.192.423v12.77c0 .153.064.295.192.423s.27.192.423.192z","fill":"#2F3146"}})])
          )
        }
      }
    